/* eslint-disable */
import { Node, Plugin, TextSelection } from 'tiptap';
import { replaceText } from 'tiptap-commands';

export default class RouterLink extends Node {
  get name() {
    return 'routerLink';
  }

  get schema() {
    return {
      attrs: {
        to: {
          default: null,
        },
        label: {
          default: null,
        },
      },
      group: 'inline',
      inline: true,
      // selectable: false,
      atom: true,
      toDOM: node => [
        'router-link',
        {
          to: node.attrs.to,
          class: 'router-link',
        },
        `${node.attrs.label}`,
      ],
      parseDOM: [
        {
          tag: 'router-link[to]',
          getAttrs: dom => {
            const to = dom.getAttribute('to');
            const label = dom.innerText;
            return { to, label };
          },
        },
      ],
    }
  }

  commands({ schema }) {
    return attrs => replaceText(null, schema.nodes[this.name], attrs)
  }
}



// WEBPACK FOOTER //
// ./src/others/router-link.js